import { Card, CardContent, Skeleton, CardActions, Button } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { useUserDetailsProjectColumns } from '../helper/userDetailsProjectColumns'
import { useUserDetailsWorkingTimeModelColumns } from '../helper/userDetailsWorkingTimeModelColumns'
import {
    defaultPageSize,
    availablePageSizes,
} from '@/schemas/searchParams/searchParamsPaginationSchema'
import { UserDetailsTableLayout } from './UserDetailsTableLayout'

export const UserDetailsPendingComponent: React.FC = () => {
    const { t } = useTranslation()
    const userDetailsProjectColumns = useUserDetailsProjectColumns()
    const userDetailsWorkingTimeModelColumns =
        useUserDetailsWorkingTimeModelColumns()

    return (
        <Card>
            <CardContent>
                <UserDetailsTableLayout
                    firstName={<Skeleton />}
                    lastName={<Skeleton />}
                    emailConfirmed={<Skeleton />}
                    email={<Skeleton />}
                    roles={<Skeleton />}
                />

                <DataGrid
                    sx={{ mt: 2 }}
                    rows={[]}
                    columns={userDetailsProjectColumns}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: defaultPageSize },
                        },
                    }}
                    pageSizeOptions={availablePageSizes}
                    disableRowSelectionOnClick={true}
                    loading={true}
                />

                <DataGrid
                    sx={{ mt: 2 }}
                    rows={[]}
                    columns={userDetailsWorkingTimeModelColumns}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: defaultPageSize },
                        },
                    }}
                    pageSizeOptions={availablePageSizes}
                    disableRowSelectionOnClick={true}
                    loading={true}
                />
            </CardContent>

            <CardActions style={{ justifyContent: 'flex-end' }}>
                <Button disabled={true}>{t('common.back')}</Button>
                <Button disabled={true} variant={'outlined'}>
                    {t('common.edit')}
                </Button>
            </CardActions>
        </Card>
    )
}
